import type { Action } from 'react-sweet-state';
import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

//**
// This hook retuen the CopyContentLink click state
//
// This will be used in content type : Whiteboard and Database
// Purpose - to decide if to show a share flag to nudge user to share the content
// if user already click CopyContentLink button in current content, the share nudge will be muted
//
// Usage
// - Whiteboard https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/confluence/next/packages/experiment-share-new-whiteboard/src/useShareNewWhiteboardFlag.tsx
//
// Project poster
// - Whiteboard https://hello.atlassian.net/wiki/spaces/cffd/pages/5161235026/Tech+Spec+-+Prompt+sharing+of+whiteboard+after+creation
// - Database https://hello.atlassian.net/wiki/spaces/cffd/pages/5193390250/Modified+requirements+for+Prompt+Sharing+of+Databases
//
//  */

type CopyContentLinkState = {
	hasClickedCopyContentLink: boolean;
};
const initialState: CopyContentLinkState = {
	hasClickedCopyContentLink: false,
};
const actions = {
	setHasClickedCopyContentLink:
		(): Action<CopyContentLinkState> =>
		({ setState }) => {
			setState({
				hasClickedCopyContentLink: true,
			});
		},
	resetHasClickedCopyContentLink:
		(): Action<CopyContentLinkState> =>
		({ setState }) => {
			setState({
				hasClickedCopyContentLink: false,
			});
		},
};
const CopyContentLinkStore = createStore({
	initialState,
	actions,
	name: 'CopyContentLinkStore',
});
export const useCopyContentLinkState = createStateHook(CopyContentLinkStore);
export const useCopyContentLinkActions = createActionsHook(CopyContentLinkStore);
